<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="saleInfo"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="商品名称">
        <el-col :span="15">
          <el-input
            v-model="saleInfo.title"
            placeholder="请选择商品"
            :disabled="true"
          ></el-input>
        </el-col>
        <el-button
          v-if="create"
          type="primary"
          size="small"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-row>
        <el-table
          :data="productInfo.product_sku"
          border
          size="mini"
          :stripe="true"
          style="width: 80%; margin: 20px 50px"
        >
          <el-table-column
            prop="title"
            label="规格"
            align="center"
            min-width="15%"
          ></el-table-column>

          <el-table-column label="商品原价" align="center" min-width="8%">
            <template slot-scope="{ row }">
              <div>{{ row.price }}&nbsp;元</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="stock"
            label="当前库存"
            align="center"
            min-width="8%"
          ></el-table-column>
          <el-table-column
            label="秒杀价格（元）"
            align="center"
            min-width="10%"
          >
            <template slot-scope="{ row }">
              <el-col :span="20">
                <el-input
                  size="mini"
                  v-model="row.flash_sale_price"
                  placeholder="秒杀价"
                ><span slot="suffix">元</span></el-input>
              </el-col>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-form-item label="秒杀图">
        <el-col class="add_flex" :span="5">
          <activityCustomUpload :formName="'img_url'" :formValue="saleInfo.img_url" @uploadSuccess="uploadSuccess"></activityCustomUpload>
          <div class="tips_msg" style="margin-left: 80px">请上传图片，支持jpeg,jpg,gif,png格式，建议尺寸为306*134、大小300kb以内</div>
        </el-col>
      </el-form-item>

      <el-form-item label="秒杀数量">
        <el-col class="add_flex">
        <el-col :span="5">
        <el-input
          v-model="saleInfo.stock"
          placeholder="请输入秒杀数量"
        ></el-input>
        </el-col>
        <div class="tips_msg">（秒杀数量最小不得小于1，最大不得大于10 0000）</div>
        </el-col>
      </el-form-item>
      <el-form-item label="虚拟数量">
        <el-col class="add_flex">
        <el-col :span="5">
        <el-input
          v-model="saleInfo.flash_sale_number_v"
          placeholder="请输入虚拟数量"
        ></el-input>
        </el-col>
        <div class="tips_msg">（前端显示的虚拟已抢数量，虚拟数量不得小于1，最大不超过10 0000）</div>
        </el-col>
      </el-form-item>
      <el-form-item label="秒杀次数">
        <el-col class="add_flex">
        <el-col :span="5">
        <el-input
          v-model="saleInfo.flash_sale_limit"
          placeholder="请输入秒杀次数"
        ></el-input>
        </el-col>
        <div class="tips_msg">（用户可秒杀该商品的次数，秒杀次数最小不得小于1，最大不超过10 0000）</div>
        </el-col>
      </el-form-item>

      <el-form-item label="秒杀时间">
        <el-date-picker
          v-model="saleInfo.begin_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择开始时间"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="saleInfo.end_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          default-time="23:59:59"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item v-if="1 == 0" label="叠加优惠">
        <el-checkbox-group
          v-model="is_discount"
          @change="checkBoxChange($event, 'is_discount')"
        >
          <el-checkbox
            label="不可叠加（所有优惠券、会员折扣、代理商折扣券均不可用）"
          ></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_vip"
          @change="checkBoxChange($event, 'discount_vip')"
        >
          <el-checkbox label="可与会员折扣叠加使用"></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_coupon"
          @change="checkBoxChange($event, 'discount_coupon')"
        >
          <el-checkbox label="可与优惠券叠加使用"></el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group
          v-model="discount_agent"
          @change="checkBoxChange($event, 'discount_agent')"
        >
          <el-checkbox label="可与代理折扣券叠加使用"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="create == true ? createInfo() : updateInfo()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  flashSaleProductScreen,
  createFlashSaleProduct,
  flashSaleInfoShow,
  flashSaleInfoUpdate,
} from "@/api/promotion";
import activityCustomUpload from "@/components/activityCustomUpload.vue";

export default {
  components: { activityCustomUpload },
  data: function () {
    return {
      create: true,
      updateLoading: false,
      productSkuShow: false,
      is_discount: true,
      discount_vip: false,
      discount_coupon: false,
      discount_agent: false,
      saleInfo: {
        id: 0,
        target_id: 0,
        type: 1, //2-课程，3-课程包，1-商品
        title: "",
        img_url: "",
        begin_at: "",
        end_at: "",
        stock: 0,
        flash_sale_number_v: 0,
        flash_sale_limit: 0,
        is_discount: 0,
        discount_vip: 0,
        discount_coupon: 0,
        discount_agent: 0,
        product_sku: "",
      },
      productInfo: {
        id: 0,
        title: "",
        product_sku: [],
      },
      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  mounted: function () {
    this.saleInfo.id = this.$route.query.id;
    if (this.saleInfo.id > 0) {
      this.create = false;
      this.getInfo();
    }
  },
  methods: {
    uploadSuccess(value){
      this.$set(this.saleInfo, value.formName, value.fileUrl)
    },
    getInfo() {
      this.loading = true;
      flashSaleInfoShow({
        id: this.saleInfo.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.saleInfo = response.data;
          this.productInfo.id = response.data.target_id;
          this.productInfo.title = response.data.title;
          this.productInfo.product_sku = response.data.product_sku;
          if (this.saleInfo.is_discount == 0) {
            this.is_discount = true;
          } else {
            this.is_discount = false;
          }
          if (this.saleInfo.discount_vip == 1) {
            this.discount_vip = true;
          } else {
            this.discount_vip = false;
          }
          if (this.saleInfo.discount_coupon == 1) {
            this.discount_coupon = true;
          } else {
            this.discount_coupon = false;
          }
          if (this.saleInfo.discount_agent == 1) {
            this.discount_agent = true;
          } else {
            this.discount_agent = false;
          }
        }
        this.loading = false;
      });
    },
    updateInfo() {
      this.saleInfo.product_sku = JSON.stringify(this.productInfo.product_sku);
      this.updateLoading = true;
      flashSaleInfoUpdate(this.saleInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/promotion/flashSaleList",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.search = "";
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      flashSaleProductScreen(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.productInfo.id = row.id;
      this.productInfo.title = row.title;
      this.productInfo.product_sku = row.product_sku;
      this.saleInfo.target_id = row.id;
      this.saleInfo.title = row.title;
      this.search.chooseOrgVisible = false;
      this.productSkuShow = true;
    },
    createInfo() {
      this.saleInfo.product_sku = JSON.stringify(this.productInfo.product_sku);
      console.log(this.saleInfo);
      this.updateLoading = true;
      createFlashSaleProduct(this.saleInfo)
        .then((response) => {
          this.updateLoading = false;
          if (response.status == 2000) {
            this.$message.success(response.message);
            this.$router.push({
              path: "/promotion/flashSaleList",
            });
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    checkBoxChange(event, discountType) {
      if (event) {
        if (discountType == "is_discount") {
          this.saleInfo.is_discount = 0;
          this.discount_vip = this.discount_coupon = this.discount_agent = false;
          this.saleInfo.discount_vip = this.saleInfo.discount_coupon = this.saleInfo.discount_agent = 0;
        }
        if (discountType == "discount_vip") {
          this.saleInfo.discount_vip = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_coupon") {
          this.saleInfo.discount_coupon = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_agent") {
          this.saleInfo.discount_agent = 1;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
      } else {
        if (discountType == "is_discount") {
          this.saleInfo.is_discount = 1;
        }
        if (discountType == "discount_vip") {
          this.saleInfo.discount_vip = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_coupon") {
          this.saleInfo.discount_coupon = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
        if (discountType == "discount_agent") {
          this.saleInfo.discount_agent = 0;
          this.saleInfo.is_discount = 1;
          this.is_discount = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.add_flex{
  display: flex;
}
.tips_msg{
  margin-left: 20px;
  flex-shrink: 0;
}
</style>